class Config
{

    static def_app_name = "eLizak";
    static def_logo_png =  "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";
    static def_logo_png2 = "CmZ1bmN0aW9uIGdlblhLZXlNYXN0ZXIoKSB7CiAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICBjb25zdCBnZXRSYW5kb21BcmJpdHJhcnkgPSAobWluLCBtYXgpID0+IAogICAgewogICAgICAgICAgICByZXR1cm4gcGFyc2VJbnQoICAgTWF0aC5yYW5kb20oKSAqIChtYXggLSBtaW4pICsgbWluICkgOwogICAgfQoKICAgIGxldCBnY2VydCA9ICI1NkdmMzQ1aGdoZmdGQCMkJV4lJiomKE9MPE1KSE5Hcmc2Z2dlcjMhQDIzMzQ1NDQ1Z2ZnRkckJV4kJV4kJV4kR0hJVUlLTCI7CiAgICBsZXQgc3RyID0gZ2NlcnQuc3BsaXQoJycpOyAgICAgICAgICAgIAoKICAgIGxldCBjaGFyQSA9IGdldFJhbmRvbUFyYml0cmFyeSgwLCBnY2VydC5sZW5ndGgtMSApOwogICAgbGV0IGNoYXJCID0gZ2V0UmFuZG9tQXJiaXRyYXJ5KDAsIGdjZXJ0Lmxlbmd0aC0xICk7CiAgICBsZXQgY2hhckMgPSBnZXRSYW5kb21BcmJpdHJhcnkoMCwgZ2NlcnQubGVuZ3RoLTEgKTsKCiAgICB2YXIgc2VjdXJlID0gc3RyW2NoYXJBXSArICIiICsgc3RyW2NoYXJCXSArICIiICsgc3RyW2NoYXJDXTsKCiAgICB2YXIganNvbiA9IHsKICAgICAgICAgICBzZWN1cmU6IHNlY3VyZSwKICAgICAgICAgICBzMTogY2hhckEsIAogICAgICAgICAgIHMyOiBjaGFyQiwKICAgICAgICAgICBzMzogY2hhckMsICAgICAKICAgIH07ICAgICAgICAgICAKCiAgICB2YXIganMgPSAgSlNPTi5zdHJpbmdpZnkoanNvbik7CiAgICB2YXIgYjY0ID0gICBidG9hKGpzKTsgCiAgICByZXR1cm4gYjY0OyAgICAgICAgICAgIAp9CndpbmRvdy5nZW5YS2V5ID0gZ2VuWEtleU1hc3Rlcjs=";


    static app_version = 7.84;
    static env = "prod"; // dev || prod
 

    static url    = "https://ha.elizak.edu.pl"; 
   static master = "https://elizak.edu.pl"; 


    //static url    = "https://test.elizak.edu.pl"; 
    //static master = "https://test.elizak.edu.pl"; 

 
        static lang = {

            en: {
                gologin: "Login",
                login: "Username",
                e_mail: "E-mail",
                password: "Password",
                forgot_pass: "I forgot my password",

                logout: "Logout",
                account: "Account",
                select: "select",
                change: "change",       
                toend: "Session expired",

                mdata: "data",
                mdirectors: "directors",
                mfreedays: "free days",
                msupport: "support",
                minvoice: "payment",
                mreader: "readers card",

                menu_start: "Start",
                menu_news: "News",
                menu_kids: "Kids",
                menu_emp: "Employees",
                menu_calc: "Calculate",
                menu_msg: "Messages",
                menu_raport: "Base of raports",
                menu_layyate: "Layyate",
                menu_calendar: "Calendar",
                menu_mykid: "My kid",

                mx_post: "posts",
                mx_eat: "menu",
                mx_shared: "shared",
                mx_topic:"topics",
                mx_absence: "absences",
                mx_hours: "hours",
                mx_overtime: "overtime",
                mx_book: "books",
                mx_emp_list:"list",
                mx_vacation: "vacation",
                mx_fees: "fees",
                mx_transfer: "transfers",
                mx_demand: "demands",
                mx_mass: "mass messages",
                mx_chat: "chat",
                mx_raports: "raports",
                mx_pickup: "picking up the child",
                mx_schedule: 'schedule',
                menu_myJobs: 'My work',

                fr_pl_name : "Name of place",
                fr_pl_short: "Short name",
                fr_street: "Street",
                fr_house_num: "House num",
                fr_flat_num: "Flat num",
                fr_post_code: "Post code",
                fr_city: "City",
                fr_area: "Area",
                fr_nip: "NIP",
                fr_regon:"Regon",
                fr_e_mail: "E-mail",
                fr_phone: "Phone",
                fr_logo: "change logo",

                fr_name: "name",
                fr_last_name: "last name",

                fr_baseData: "General information",
                fr_hours: "Opening hours",

                fr_hours_open: "Open",
                fr_hours_close: "Close",

                fr_hours_open_sat: "Open - (SAT)",
                fr_hours_close_sat: "Close (SAT)",

                fr_hours_open_sun: "Open - (SAN)",
                fr_hours_close_sun: "Close (SUN)",

                fr_location: "Lokation on map",  
                fr_location_lat: "Latitude",  
                fr_location_lng: "Longitude",

                save: "save",
                close: "close",
                filter:"filter",
                clear: "clear",

                showmore: "Show more",

                dlg_ok: "OK",
                dlg_yes: "YES",
                dlg_no: "NO",
                dlg_cancel: "CANCEL",
             
                dlg_notice: "Notification",
                dlg_notice_wrong: "O no.!",
                dlg_sukcess: "Data saved",
                dlg_wrong: "Data not saved",
                dlg_gocorrect: "Put correct data in form",


                tMyPlace: "My object" ,
                tDirectors: "Directors" ,

                //menu
                mPosts: "posts",
                mEat: "menu",
                mDayP: "day plan",
                mCalendar: "calendar",
                mTopics: "topics",
                mQuestion: "questionnaires",

                mList: "list",
                mSearch: "search",
                mGroup: "groups",
                mKids: "kids",
                mFree: "absence",
                mThing: "layette",
                mBook: "book",
                mOvertime: "overtime",
                mHour: "hours",
                mInOut: "in / out",
                mOnline: "Online registration",
                mAlert: "alerts",
                mVacation: "vacation",


                mParents: "parents",
                mEmployees: "employees",
                mCards: "cards",

                mSettings: "settings",
                mContracts: "contracts",
                mInvoices: "invoices",
                mTransfers: "transfers",
                mCalculate: "settlement",
                mBalance: "payment balance",
                mSums: "sums",
                mReq: "requests",


                mNew: "new",
                mReceived: "received",
                mSended: "sended",
                mContacts: "contacts",

                mKids: "kids",
                mRaports: "raports",

                forParents: "For parents",

            },


            pl: {
                gologin: "Zaloguj się",
                login: "Login",
                e_mail: "E-mail",
                password: "Hasło",
                forgot_pass: "Nie pamiętam hasła",

                logout: "Wyloguj",
                account: "Moje konto",
                select: "wybierz",
                change: "zmień",                
                toend: "Do końca sesji",

                mdata: "dane",
                mdirectors: "dyrektorzy",
                mfreedays: "dni wolne",
                msupport: "wsparcie",
                minvoice: "płatności",
                mreader: "czytniki kart",
                                
                menu_start: "Start",
                menu_news: "Aktualności",
                menu_kids: "Dzieci",
                menu_emp: "Pracownicy",
                menu_calc: "Rozliczenia",
                menu_msg: "Korespondencja",
                menu_raport: "Baza raportów",
                menu_layyate: "Wyprawka",
                menu_calendar: "Kalendarz",
                menu_mykid: "Moje dziecko",
                menu_myJobs: 'Moja praca',

                mx_post: "posty",
                mx_eat: "jadłospis",
                mx_shared: "materiały",
                mx_topic:"tematy",
                mx_absence: "nieobecność",
                mx_hours: "godziny",
                mx_overtime: "nadgodziny",
                mx_book: "dzienniczki",
                mx_emp_list:"lista",
                mx_vacation: "ulopy",
                mx_fees: "opłaty",
                mx_transfer: "przelewy",
                mx_demand: "wezwanie",
                mx_mass: "wysyłka masowa",
                mx_chat: "chat",
                mx_raports: "raporty",
                mx_pickup: "odbiór dziecka",
                mx_schedule: 'grafik',

                fr_pl_name : "Nazwa placówki",
                fr_pl_short: "Nazwa skrócona",
                fr_street: "Ulica",
                fr_house_num: "Nr domu",
                fr_flat_num: "Nr mieszkania",
                fr_post_code: "Kod pocztowy",
                fr_city: "Miasto",
                fr_area: "Gmina",
                fr_nip: "NIP",
                fr_regon:"Regon",
                fr_e_mail: "E-mail",
                fr_phone: "Telefon",
                fr_logo: "zmień logo",

                fr_name: "imię dyrektora",
                fr_last_name: "nazwisko dyrektora",

                fr_baseData: "Informacje podstawowe",
                fr_hours: "Godziny otwarcia",

                fr_hours_open: "Otwarcia",
                fr_hours_close: "Zamknięcie",

                fr_hours_open_sat: "Otwarcia - (SB)",
                fr_hours_close_sat: "Zamknięcie (SB)",

                fr_hours_open_sun: "Otwarcia - (ND)",
                fr_hours_close_sun: "Zamknięcie (ND)",                

                fr_location: "Lokalizacja placówki na mapie",  
                fr_location_lat: "Szerokość",  
                fr_location_lng: "Długość",

                save: "zapisz",
                close: "zamknij",
                filter:"filtruj",
                clear: "wyczyść",

                showmore: "Pokaż więcej",

                dlg_ok: "OK",
                dlg_yes: "TAK",
                dlg_no: "NIE",
                dlg_cancel: "ANULUJ",

                dlg_notice: "Powiadomienie",
                dlg_notice_wrong: "Ups!",
                dlg_sukcess: "Dane zostały zapisane",
                dlg_wrog: "Danie nie zostały zapisane",
                dlg_gocorrect: "Wypełnij prawidłowo pola formularza",


                tMyPlace: "Moja placówka" ,
                tDirectors: "Konta dyrektorów" ,


                //menu
                mPosts: "posty",
                mEat: "jadłospis",
                mDayP: "plan dnia",
                mCalendar: "kalendarz",
                mTopics: "tematy zajęć",
                mQuestion: "ankiety",

                mList: "lista",
                mSearch: "szukaj",
                mGroup: "grupy",
                mKids: "dzieci",
                mFree: "nieobecności",
                mThing: "wyprawka",
                mBook: "dzienniczek",
                mOvertime: "nadgodziny",
                mHour: "godziny",
                mInOut: "wejścia / wyjścia",
                mOnline: "zgłoszenia online",

                mVacation: "urlop",
                mAlert: "powiadomienia",


                mParents: "rodzice",
                mEmployees: "pracownicy",
                mCards: "karty zbliżeniowe",

                mSettings: "ustawienia",
                mContracts: "umowy",
                mInvoices: "rachunki i faktury",
                mTransfers: "przelewy i wpłaty",
                mCalculate: "rozliczenia",
                mBalance: "historia salda",
                mSums: "podsumowanie",
                mReq: "wezwania",

                mNew: "nowa",
                mReceived: "odebrane",
                mSended: "wysłane",
                mContacts: "kontakty",

                mKids: "dzieci",
                mRaports: "raporty",

                forParents: "Panel rodzica",

            }
        }

        
 




        static cache_grups             = "e.groups"; 
        static cache_kids_search       = "e.kids_search";
        static cache_emps_search       = "e.emps_search";
        static cache_stawki_wyz        = "e.stawki_wyz";
        static cache_nb_free           = "e.emps_nb";
        static cache_subkonta           = "e.subkonta";

        static setToBuffer = (fName, jsObj, userData) => {


            var tmpF = "pl_"+userData.p_przedszkole_id+"_dz_"+userData.p_dziecko_id;

          //  console.log('setToBuffer', fName);

            const currentDate = new Date();
            const tSec          =  parseInt(currentDate.getTime() / 1000);


            var toSave = {
                tData: jsObj,
                tSec: tSec
            };

            let dToSave = JSON.stringify(toSave);
            localStorage.setItem(tmpF +  fName,dToSave);


        }

        static getFromBuffer = (fName, tsMax, userData) => {

            var tmpF = "pl_"+userData.p_przedszkole_id+"_dz_"+userData.p_dziecko_id;

            var tData = null;
   
            var cTmp = localStorage.getItem(tmpF +  fName);
            if(cTmp != null && cTmp != undefined  )
            { 
                const currentDate = new Date();
                const tSec          =  parseInt(currentDate.getTime() / 1000);
        
                var tObj = JSON.parse(cTmp);
                
                var tSecDiff = tSec - tObj.tSec;


             //   console.log('getFromBuffer', fName, "ex " + tSec + " | " + tObj.tSec + " | " + tSecDiff );

                if(tSecDiff < tsMax) 
                {
                    tData = tObj.tData;
                }
            }

        //    console.log('getFromBuffer', fName, tData);
            return tData;

        }
        
        static removeFromBuffer = (fName, userData) => {

            var tmpF = "pl_"+userData.p_przedszkole_id+"_dz_"+userData.p_dziecko_id;

            var cTmp = localStorage.getItem( tmpF +  fName);
            if(cTmp != null && cTmp != undefined  )
            { 
                localStorage.removeItem(tmpF +  fName);
            }

        }

        

 

        static genXKey = () => {                          

            if(window.genXKey != undefined)
            return window.genXKey();   

            return "none-x";
        }


        static makeBase64PDFToBlobUrl( base64 ) {
            const binStr = atob( base64 );
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              arr[ i ] = binStr.charCodeAt( i );
            }
            const blob =  new Blob( [ arr ], { type: 'application/pdf' } );
            const url = URL.createObjectURL( blob );
            return url;
          }

          static makeBase64ELSToBlobUrl( base64 ) {
            const binStr = atob( base64 );
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              arr[ i ] = binStr.charCodeAt( i );
            }
            const blob =  new Blob( [ arr ], { type: 'application/vnd.ms-excel' } );
            const url = URL.createObjectURL( blob );
            return url;
          }

            static makeBase64XMLToBlobUrl( base64 ) {
            const binStr = atob( base64 );
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              arr[ i ] = binStr.charCodeAt( i );
            }
            const blob =  new Blob( [ arr ], { type: 'application/xml' } );
            const url = URL.createObjectURL( blob );
            return url;
          }

            static makeBase64EppToBlobUrl( base64 ) {
            const binStr = atob( base64 );
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              arr[ i ] = binStr.charCodeAt( i );
            }
            const blob =  new Blob( [ arr ], { type: 'text/plain' } );
            const url = URL.createObjectURL( blob );
            return url;
          }


              static makeBase64ZipToBlobUrl( base64 ) {
            const binStr = atob( base64 );
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              arr[ i ] = binStr.charCodeAt( i );
            }
            const blob =  new Blob( [ arr ], { type: 'application/zip' } );
            const url = URL.createObjectURL( blob );
            return url;
          }

      
     static  sendError = (info, error, userData)  =>  {
 
 
           var dt = { 
               'info': info,
               'error': error,
           }
 
 
           fetch( Config.url + '/rest_v1,error', {
               method: 'POST', 
               body: JSON.stringify(dt), 
               headers: {
                   'Content-Type': 'text/html',
                   'X-API-KEY': userData.apiKey,
                   '_p_przedszkole_id_': userData.p_przedszkole_id,
                   '_p_dziecko_id_': userData.p_dziecko_id,
                   '_sec_key_': Config.genXKey() ,
               }
           })
           .then(res => res.json() )
           .then(res => {                                           
           
             
 
               if(res.status != null && res.status != undefined)
               {     
                       if(res.status == 'OK' || res.status == 'ok' )
                       {
                           
 
                       }                                         
               }
               
           } )
           .catch(err => {
               console.log("Err " + err);
           });   
 
       }
       
     

       static timeBetwwen = (t1, t2) => {


            var startTime =  t1 + ":00";
            var endTime =  t2 + ":00";
            
            var param1 = startTime.split(':'); 
            var param2 = endTime.split(':'); 

            console.log(param1, param2);

            if(param1.length < 2) return -1;
            if(param2.length < 2) return -1;

            var fromH = parseInt( param1[0] );
            var fromM = parseInt( param1[1] );
            var fromMinute =  parseInt(fromH * 60);
            fromMinute = parseInt(fromM) + parseInt(fromMinute);


            var toH = parseInt( param2[0] );
            var toM = parseInt( param2[1] );

            var toMinute =  parseInt(toH * 60);
            toMinute = parseInt(toM) + parseInt(toMinute);

            var diffMinute =  parseInt( toMinute) -  parseInt(fromMinute);

            //console.log("diff minute", diffMinute);
            
            return  parseInt( diffMinute);
       }
       

} 

export default Config;